import Sidebar from "./Sidebar";

  const Layout = ({ children }) => {
    return (
      <div className="Layout">
        <div>
          <Sidebar />
        </div>
        <main>
          {children}
        </main>
      </div>
    );
  };

  export default Layout;